import React, { useEffect, useState } from "react";
import "./style.scss";
import { Button, Modal, Table } from "react-bootstrap";
import SearchIcon from "../../icons/SearchIcon";
import BusinessIcon from "../../icons/BusinessIcon";
import CalendarIcon from "../../icons/CalendarIcon";
import { cancelBooking, getBookingDetails, getBookinglist } from "../../services/bookings.service";
import { all_routes } from "../router/all_routes";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { AxiosError } from "axios";
import { CommonPagination } from "../../core/components/common/CommnPagination";
import { formatBookingTime } from "../../utils";

export default function Booking() {
  const [show, setShow] = useState(false);
  const [selectedBooking, setSelectedBooking] = useState<any>(null); // To hold selected booking details
  const [searchTerm, setSearchTerm] = useState<string>('');
  const [startDate, setStartDate] = useState<string>('');
  const [endDate, setEndDate] = useState<string>('');
  const [currentPage, setCurrentPage] = useState<number>(1);  // Track current page
  const [totalItems, setTotalItems] = useState<number>(0);  // Track total number of items
  const itemsPerPage = 10; // Number of items per page
  const [bookinglist, setBookinglist] = useState<any[]>([]);
  const navigate = useNavigate();
  const route = all_routes;


  useEffect(() => {
    getBookings(currentPage, startDate, endDate, searchTerm);
  }, [currentPage, searchTerm, startDate, endDate]);

  const getBookings = async (page: number, startDate: string, endDate: string, searchTerm: string) => {
    let skip = (page - 1) * itemsPerPage;

    try {
      const payload = {
        search: searchTerm,
        startDate: startDate,
        endDate: endDate,
        skip,
        limit: itemsPerPage,
      };
      const result = await getBookinglist(payload);
      setBookinglist(result?.data?.data || []);
      setTotalItems(result?.data?.totalRecord || 0)
    } catch (error) {
      console.error(error);
    }
  };

  const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchTerm(event.target.value);
    setCurrentPage(1); // Reset to the first page on new search
  };

  const handlePageChange = (newPage: number) => {
    setCurrentPage(newPage);
  };

  const handleShow = async (bookingId: string) => {
    setShow(true);

    try {
      const result = await getBookingDetails(bookingId);
      setSelectedBooking(result?.data?.data || null);
    } catch (error) {
      console.error("Failed to fetch booking details:", error);
      setSelectedBooking(null);
    }
  };

  const handleClose = () => {
    setShow(false);
    setSelectedBooking(null);
  };

  const handleCheckIn = async (bookingId: string | undefined) => {
    if (!bookingId) return;
    try {
      navigate(route.checkIn);
    } catch (error) {
      toast.error("Check-in was unsuccessful. Please try again or contact support if the issue persists")
    }
  };

  const handleCancel = async (bookingId: string | undefined) => {
    if (!bookingId) return;
    try {
      const result = await cancelBooking(bookingId);

      if (result?.data?.responseCode === 404) {
        toast.error(result?.data?.responseMessage)
      }
      else {
        toast.success(result?.data?.responseMessage);
      }
      setShow(false);
      setSelectedBooking(null);
      getBookings(currentPage, startDate, endDate, searchTerm);
    } catch (error) {
      if (error instanceof AxiosError) {
        toast.error(error.response?.data?.responseMessage)
      }
    }
  };

  return (
    <>
      <div className="bookingWrapper">
        <div className="container">
          <h3>Bookings</h3>
          <div className="bgFormColor p-4 my-4">
            <div className="searchWrap">
              <form>
                <button>
                  <SearchIcon />
                </button>
                <input
                  className="form-control"
                  type="text"
                  placeholder="Search booking ... "
                  value={searchTerm}
                  onChange={handleSearchChange}
                />
              </form>
            </div>

            <div className="table-responsive">
              <Table className="tableWrapper">
                <thead>
                  <tr>
                    <th>Class name</th>
                    <th>Booking date time</th>
                    <th>Visitor Name</th>
                    <th>Status / Action</th>
                  </tr>
                </thead>

                <tbody>
                  {bookinglist?.length > 0 ? (
                    bookinglist.map((booking, index) => {

                      return (
                        <tr key={index}>
                          <td>
                            <span className="underline">{booking?.className.charAt(0).toUpperCase() + booking?.className.slice(1)}</span>
                          </td>

                          <td>{booking?.bookingStartDateTime ? formatBookingTime(booking?.bookingStartDateTime) : "-"}</td>

                          <td>{`${booking?.employeeDetails?.firstName.charAt(0).toUpperCase() + booking?.employeeDetails?.firstName.slice(1)} ${booking?.employeeDetails?.lastName.charAt(0).toUpperCase() + booking?.employeeDetails?.lastName.slice(1)}`}</td>
                          <td>
                            <div className="d-flex gap-2 align-items-center action_result">
                              <span
                                className={
                                  booking?.status?.toLowerCase() === "confirmed" ? "text-success" : "text-danger"}
                              >
                                {booking?.status.charAt(0).toUpperCase() + booking?.status.slice(1)}
                              </span>
                              <button onClick={() => handleShow(booking?._id)} className="confirmBtn">
                                Details
                              </button>
                            </div>
                          </td>
                        </tr>
                      );
                    })
                  ) : (
                    <tr>
                      <td colSpan={4} className="text-center">
                        No bookings found.
                      </td>
                    </tr>
                  )}
                </tbody>
              </Table>

              <div className="paginationWrapper">
                <CommonPagination
                  totalRecords={totalItems}
                  recordsPerPage={itemsPerPage}
                  onPageChange={handlePageChange}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* modal start */}
      <Modal
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        show={show}
        onHide={handleClose}
        className="confirmModal"
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">Booking</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {selectedBooking ? (
            <div>
              <div className="modalImg">
                <img className="w-100" src={"/assets/img/modalImage.jpg"} alt="modalImage" />
              </div>
              <div className="game_content">
                <label>
                  <BusinessIcon /> {" "}
                  <span className="underline">
                    {selectedBooking?.partnerDetails?.businessName ? selectedBooking?.partnerDetails?.businessName : selectedBooking?.partnerDetails?.name}
                  </span>
                </label>
                <h2>{selectedBooking?.className.charAt(0).toUpperCase() + selectedBooking?.className.slice(1)}
                </h2>
                <label className="dateWrap">
                  <CalendarIcon />
                  {selectedBooking?.bookingStartDateTime ? formatBookingTime(selectedBooking?.bookingStartDateTime) : "-"}
                </label>
                <div className="bgFormColor p-4 my-3">
                  <h3>Booking person details</h3>
                  <div className="bookDetail">
                    <ul>
                      <li className="d-flex justify-content-between"><label>Full name :</label>
                        <h4> {`${selectedBooking?.employeeDetails?.firstName.charAt(0).toUpperCase() + selectedBooking?.employeeDetails?.firstName.slice(1)} ${selectedBooking?.employeeDetails?.lastName.charAt(0).toUpperCase() + selectedBooking?.employeeDetails?.lastName.slice(1)}`}</h4>
                      </li>
                      <li className="d-flex justify-content-between"><label>Email id :</label><h4> {selectedBooking?.employeeDetails?.email}</h4></li>
                      <li className="d-flex justify-content-between"><label>Contact :</label><h4>{selectedBooking?.employeeDetails?.phone}</h4></li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <p>Loading booking details...</p>
          )}
        </Modal.Body>

        <Modal.Footer className="w-100 direction-column justify-content-center">
          {selectedBooking?.status?.toLowerCase() !== "cancelled" &&
            selectedBooking?.status?.toLowerCase() !== "late cancelled" &&
            selectedBooking?.status?.toLowerCase() !== "checked-in" && (
              <div>
                <Button onClick={() => handleCheckIn(selectedBooking?._id)} className="w-100 mb-2">Check-in</Button>

                {/* Calculate if cancel button should be shown */}
                {new Date(`${selectedBooking?.bookingDate}T${selectedBooking?.startTime}`) > new Date(Date.now() + 60 * 60 * 1000) && (
                  <Button variant="outline-danger" onClick={() => handleCancel(selectedBooking?._id)} className="w-100 mb-2">Cancel</Button>
                )}

              </div>
            )}

          {selectedBooking?.status?.toLowerCase() === "cancelled" && (
            <div className="dangerCancel d-flex align-items-center border-danger border">
              <label className="mb-0 p-2">This booking has been cancelled.</label>
            </div>
          )}
        </Modal.Footer>
      </Modal>
    </>
  );
}
